import { onboardData } from './shared/state';

export default {
  namespaced: true,
  modules: {
    onboardData
  }
};
